import { Entity } from '@backstage/catalog-model';
import { isSecurityInsightsAvailable } from '@roadiehq/backstage-plugin-security-insights';

export const isGitHubDependabotAvailable = (entity: Entity): boolean => {
  return isSecurityInsightsAvailable(entity);
};
 